import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "badge", "rows"];

  connect() {
    if (!this.hasSelectTarget) return;

    this.updateBadge();
    this.updateRows();

    this.element.addEventListener('content-summary:updateContent', () => {
      setTimeout(() => {    
        this.updateBadge();
        this.updateRows();
      }, 1000);
    });

    this.disableOptionsIfNeeded();

    // Prevent Enter key from submitting the form when focused on specific inputs
    this.keydownHandler = this.preventEnterSubmit.bind(this);
    this.element.addEventListener("keydown", this.keydownHandler, true);
  }

  disconnect() {
    if (this.keydownHandler) {
      this.element.removeEventListener("keydown", this.keydownHandler, true);
    }
  }

  preventEnterSubmit(e) {
    const selectors = [
      ".course-form__input",
      'input[type="checkbox"]',
      ".search-field",
      "select"
    ];
    if (
      selectors.some(sel => e.target.matches(sel)) &&
      e.key === "Enter"
    ) {
      e.preventDefault();
      return false;
    }
  }

  onChange() {
    this.updateBadge();
    this.updateRows();
    this.disableOptionsIfNeeded();
  }

  updateBadge() {
    const count = this.selectTarget.value === '-' ? 0 : parseInt(this.selectTarget.value, 10);
    this.badgeTargets.forEach((badge) => {
      if (badge) {
        badge.textContent = `${count} Student Choice Case${count === 1 ? '' : 's'}`;
      }
    });
  }

  updateRows() {
    const count = this.selectTarget.value === '-' ? 0 : parseInt(this.selectTarget.value, 10);
    let html = '';
    if (count > 0) {
      html = `<div data-document-removal-target="row" data-document-type="student_choice_case" data-document-time="${count * 1800}"></div>`;
    }
    this.rowsTarget.innerHTML = html;
    // Also trigger the event for recalculation
    const event = new CustomEvent('student-choice-cases:changed', { bubbles: true });
    this.element.dispatchEvent(event);
  }

  disableOptionsIfNeeded() {
    const select = this.selectTarget;
    const courseStarted = select.dataset.courseStarted === "true";
    const currentValue = parseInt(select.dataset.currentValue, 10);
    Array.from(select.options).forEach(option => {
      if (option.value === "") {
        option.disabled = false;
        return;
      }
      const val = parseInt(option.value, 10);
      option.disabled = courseStarted && val < currentValue;
    });
  }
}
